<form [formGroup]="form" class="duration">
    <input formControlName="hours"
           #hours (click)="hours.select()"
           (blur)="formatFields()"
           [placeholder]="'hh' | translate"
           matInput id='h'
           type='number'
           min='0' max='24'
           maxlength="2"
    >
    <label for='h'>:</label>
    <input formControlName="minutes"
           #minutes (click)="minutes.select()"
           (blur)="formatFields()"
           [placeholder]="'mm' | translate"
           matInput id='m' type='number'
           min='0' max='59'
           size="2"
    >
    <label for='m'>:</label>
    <input formControlName="seconds"
           #seconds (click)="seconds.select()"
           (blur)="formatFields()"
           [placeholder]="'ss' | translate"
           matInput id='s' type='number'
           min='0' max='59'
           size="2"
    >
</form>
